import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import { Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { SECTIONS, reportActions } from '../../../store/reportStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import GreenSemaphore from '../../../img/icons/GreenSemafor';
import YellowSemaphore from '../../../img/icons/YellowSemafor';
import RedSemaphore from '../../../img/icons/RedSemafor';
import HistoryLink from '../../common/historyLink';
import RelationLink from './relationLink';
import Paging from '../../common/pagingComponent';
import BbCollapse from "../../common/BbCollapse";

import './relations.scss';

class RelationSubjectsData extends React.Component {
    static propTypes = {
        historicalRelations: PropTypes.bool,
        ownerRelations: PropTypes.bool,
        pageSize: PropTypes.number
    };

    static defaultProps = {
        historicalRelations: false,
        ownerRelations: false,
        pageSize: 200
    };

    state = {
        historyExpanded: false,
        isHistoryExpandedTouched: false,
        pageActual: 1,
        pageHistorical: 1
    };
    tableMargin = { marginBottom: '1.5em' };

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated)
            this.setState({ isHistoryExpandedTouched: false });
    }

    render() {
        if (isNullOrUndefined(this.props.data) || this.props.data.length === 0)
            return null;

        return this.props.historicalRelations
            ? this.renderHistoricalData(this.props.data, this.props.ownerRelations)
            : this.renderActualData(this.props.data, this.props.ownerRelations);
    }

    toggleHistory = () => {
        this.setState({
            historyExpanded: !this.props.resolveExpanded(this.state.historyExpanded, this.state.isHistoryExpandedTouched),
            isHistoryExpandedTouched: true
        });
    }

    renderActualData = (data, ownerRelations) => {
        const min = this.props.isLimited ? 0 : (this.state.pageActual - 1) * this.props.pageSize;
        const max = this.getMaxItemIndex(data.length, this.props.isLimited, false);

        return (
            <>
                <div style={{ paddingTop: ".25em" }}></div>
                <table className="table table-report-section related-addresses fixed with-ellipsed-column old-style-table-report"
                    style={this.tableMargin}>
                    <thead>
                        <tr>
                            <th style={{ width: '3em' }} />
                            <th className="w-39"><Translate id="Report.Relations.EntityName" /></th>
                            <th className="w-10"><Translate id="Report.Relations.EntityIdentification" /></th>
                            <th className="w-19"><Translate id="Report.Relations.Position" /></th>
                            <th className="w-15">{ownerRelations ? <Translate id="Report.Relations.ShareDeposit" /> : null}</th>
                            {/* <th className="w-10"><Translate id="Report.Relations.WarningInfo" /></th> */}
                            <th className="w-10"><Translate id="Report.Common.ValidFrom" /></th>
                            <th className="w-10"></th>
                            <th style={{ width: '6em' }}><Translate id="Report.Relations.Country" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.slice(min, max).map(r => <tr key={r.id} className='colorize'>
                            <td className={classnames('semaphore-td', { 'hidden': this.renderSemaphore(r.semaphoreCode) === null })}>
                                <div>{this.renderSemaphore(r.semaphoreCode)}</div>
                            </td>
                            <td>
                                <RelationLink wrap entityName={r.name} entityId={r.entityId} reports={r.reports} customPrefix={<></>} />
                            </td>
                            <td>{this.renderEntityIdentification(r)}</td>
                            <td colSpan={ownerRelations ? 1 : 2}>{r.position}</td>
                            {ownerRelations ? <td style={{ display: "table-cell" }}>
                                {this.renderOwnerShare(r)}</td> : null}
                            {/* <td>{this.renderWarnings(r.warnings)}</td> */}
                            <td colSpan={2}>{r.startDateFormatted}</td>
                            <td title={r.country}>{r.countryCode}</td>
                        </tr>)}
                    </tbody>
                </table>
                {this.renderPaging(data.length, false)}
            </>
        );
    }

    renderHistoricalData = (data, ownerRelations) => {
        const min = this.props.isLimited ? 0 : (this.state.pageHistorical - 1) * this.props.pageSize;
        const max = this.getMaxItemIndex(data.length, this.props.isLimited, true);

        return (
            <>
                <HistoryLink historyExpanded={this.props.resolveExpanded(this.state.historyExpanded, this.state.isHistoryExpandedTouched)} onClick={this.toggleHistory} />
                <BbCollapse isOpen={this.props.resolveExpanded(this.state.historyExpanded, this.state.isHistoryExpandedTouched)} >
                    <table className="table table-report-section table-report-history related-addresses fixed with-ellipsed-column">
                        <thead>
                            <tr>
                                <th style={{ width: '3em' }} />
                                <th className="w-39"><Translate id="Report.Relations.EntityName" /></th>
                                <th className="w-10"><Translate id="Report.Relations.EntityIdentification" /></th>
                                <th className="w-19"><Translate id="Report.Relations.Position" /></th>
                                <th className="w-15">{ownerRelations ? <Translate id="Report.Relations.ShareDeposit" /> : null}</th>
                                {/* <th className="w-10"><Translate id="Report.Relations.WarningInfo" /></th> */}
                                <th className="w-10"><Translate id="Report.Common.ValidFrom" /></th>
                                <th className="w-10"><Translate id="Report.Common.ValidTo" /></th>
                                <th style={{ width: '6em' }}><Translate id="Report.Relations.Country" /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.slice(min, max).map(r => <tr key={r.id} className='colorize'>
                                <td className={classnames('semaphore-td', { 'hidden': this.renderSemaphore(r.semaphoreCode) === null })}>
                                    <div>{this.renderSemaphore(r.semaphoreCode)}</div>
                                </td>
                                <td>
                                    <RelationLink entityName={r.name} entityId={r.entityId} reports={r.reports} historical customPrefix={<></>} />
                                </td>
                                <td>{this.renderEntityIdentification(r)}</td>
                                <td colSpan={ownerRelations ? 1 : 2}>{r.position}</td>
                                {ownerRelations ? <td style={{ display: "table-cell" }} >{this.renderOwnerShare(r)}</td> : null}
                                {/* <td>{this.renderWarnings(r.warnings, true)}</td> */}
                                <td>{r.startDateFormatted}</td>
                                <td>{r.endDateFormatted}</td>
                                <td title={r.country}>{r.countryCode}</td>
                            </tr>)}
                        </tbody>
                    </table>
                    {this.renderPaging(data.length, true)}
                </BbCollapse>
            </>
        );
    }

    renderSemaphore = (code, hideOnDesktop) => {
        if (code === undefined || code === null)
            return null;

        if (code === 1)
            return <GreenSemaphore />
        else if (code === 2)
            return <YellowSemaphore />
        else if (code === 3)
            return <RedSemaphore />

        return null;
    }

    renderWarnings = (warnings, historical = false) => {
        if (warnings === undefined || warnings === null || warnings.length === 0)
            return null;

        return (
            <React.Fragment>
                <div style={{ display: "flex", whiteSpace: "pre-wrap", flexWrap: 'wrap' }}>
                    {warnings.map((w, i) =>
                        <div key={`${i}_${w.code}`} className={`r-padded rel-warn rel-warn-status-${w.severity}${(historical ? " rel-warn-historical" : "")}`}
                            title={w.description}
                        >{w.code}
                        </div>)}
                </div>
            </React.Fragment>
        );
    }

    renderEntityIdentification = (entity) => {
        if (entity === undefined || entity === null)
            return null;

        if (entity.birthDate !== undefined && entity.birthDate !== null)
            return entity.birthDateFormated;
        else
            return entity.companyId;
    }

    renderOwnerShare = (entity) => {
        if (entity === undefined || entity === null)
            return null;

        if (entity.share === null && entity.depositValue === null)
            return null;

        return (
            <React.Fragment>
                <span style={{ whiteSpace: "nowrap", display: "inline-flex" }}>{entity.shareFormated}<span className="l-padded r-padded">/</span></span>
                <span style={{ whiteSpace: "nowrap", display: "inline-flex" }}>{entity.depositValueFormated}&nbsp;</span>
                <span>
                    {entity.currencyUnit === 1000 && <><Translate id="Report.Common.CurrencyThousands" /><span className="l-padded" /></>}
                    {entity.currency}
                </span>
            </React.Fragment>
        );
    }

    renderPaging = (count, historical) => {
        return (
            <>
                {this.props.isLimited && count > this.props.pageSize && <a className="link-functional" target="_blank"
                    href={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, SECTIONS.relationsData)}
                >
                    <Translate id="Report.Common.ShowAll" />&nbsp;({count})
                </a>}
                {!this.props.isLimited && count > this.props.pageSize && <div style={{ marginTop: "2em" }}>
                    <Paging
                        justify="center"
                        selectedPage={historical ? this.state.pageHistorical : this.state.pageActual}
                        totalPages={Math.ceil(count / this.props.pageSize)}
                        setPage={page => historical ? this.setState({ pageHistorical: page }) : this.setState({ pageActual: page })}
                    />
                </div>}
            </>
        );
    }

    getMaxItemIndex = (count, isLimited, historical) => {
        if (isLimited)
            return count < this.props.pageSize ? count : this.props.pageSize;

        var page = historical ? this.state.pageHistorical : this.state.pageActual;

        return this.props.pageSize * page > count
            ? count : this.props.pageSize * page;
    }

    isEmpty = (str) => {
        if (isNullOrUndefined(str))
            return true;
        if (str.trim() === '')
            return true;
        else
            return false;
    }

    isEmptyCountry = (c) => {
        return this.isEmpty(c) || c === 'XX';
    }

    concatAddress = (address) => {
        if (isNullOrUndefined(address))
            return "";
        var ret = "";
        if (!this.isEmpty(address.street)) {
            ret += address.street;
            if (!this.isEmpty(address.zip) || !this.isEmpty(address.city) || !this.isEmptyCountry(address.country))
                ret += ', ';
        }
        if (!this.isEmpty(address.zip)) {
            ret += address.zip;
            if (!this.isEmpty(address.city))
                ret += ' ';
            else
                if (!this.isEmptyCountry(address.country))
                    ret += ', ';
        }
        if (!this.isEmpty(address.city)) {
            ret += address.city;
            if (!this.isEmptyCountry(address.country))
                ret += ', ';
        }
        if (!this.isEmptyCountry(address.country))
            ret += address.country;

        return ret;
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(RelationSubjectsData));